<template>
    <div class="curriculum">
        <router-view></router-view>

    </div>
</template>

<script>

export default {
    //import引入组件才能使用
    components: {},
    props: {},
    data() {
        return {

        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {

    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {

    },
}
</script>
<style scoped>

</style>